import { useLayoutEffect } from 'react';
import styles from './usePreventScroll.module.scss';

const usePreventScroll = (enabled = true) => {
  useLayoutEffect(() => {
    if (enabled) {
      document.body.classList.add(styles.prevent_scroll);
    } else {
      document.body.classList.remove(styles.prevent_scroll);
    }

    return () => {
      document.body.classList.remove(styles.prevent_scroll);
    };
  }, [enabled]);
};

export default usePreventScroll;
